export const LOW_TEMP = 90
export const HIGH_TEMP = 106
export const STOP_TEMP = 100.0
export const CONFIRM_LOW_TEMP = 95.9
export const CONFIRM_HIGH_TEMP = 101

export const LOW_PULSE = 20
export const HIGH_PULSE = 175
export const CONFIRM_LOW_PULSE = 59
export const CONFIRM_HIGH_PULSE = 111

export const LOW_RESPIRATION = 5
export const HIGH_RESPIRATION = 40
export const CONFIRM_LOW_RESPIRATION = 11
export const CONFIRM_HIGH_RESPIRATION = 25

export const LOW_OXYGEN = 70
export const HIGH_OXYGEN = 100
export const CONFIRM_LOW_OXYGEN = 94

export const LOW_SYSTOLIC = 50
export const HIGH_SYSTOLIC = 229
export const CONFIRM_LOW_SYSTOLIC = 99
export const CONFIRM_HIGH_SYSTOLIC = 140

export const LOW_DIASTOLIC = 30
export const HIGH_DIASTOLIC = 130
export const CONFIRM_LOW_DIASTOLIC = 59
export const CONFIRM_HIGH_DIASTOLIC = 90
